module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Ssfooter has-text-left"
  }, [_c('div', {
    staticClass: "container is-fluid"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-1 is-3-mobile"
  }, [_c('router-link', {
    attrs: {
      "to": "/privacy-policy"
    }
  }, [_c('p', [_vm._v("Privacy Policy")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-1 is-3-mobile"
  }, [_c('router-link', {
    attrs: {
      "to": "/cookie-policy"
    }
  }, [_c('p', [_vm._v("Cookie Policy")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-1 is-3-mobile"
  }, [_c('router-link', {
    attrs: {
      "to": "/legal-notices"
    }
  }, [_c('p', [_vm._v("Legal Notices")])])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column is-8 has-text-centered is-12-mobile"
  }, [(this.$root._route.meta.policy) ? _c('p', [_vm._v("This website uses cookies. Please read more from cookie policy.")]) : _c('p')]), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-3-mobile is-hidden-desktop"
  }, [_c('img', {
    attrs: {
      "src": "/static/ssl.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-1 is-12-mobile is-hidden-mobile"
  }, [_c('img', {
    attrs: {
      "src": "/static/ssl.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f1b8c950","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer.vue
// module id = 63
// module chunks = 0